import { NgModule } from '@angular/core';

import { DynamicReportRoutesModule } from './dynamic-report.routes';
import { DynamicReportComponent } from './dynamic-report.component';
import { BaseModule } from '../../../../shared/base.module';
import { PaginationModule } from '../../../../shared/pagination/pagination.module';
import { DynamicReportPieChartModule } from '../../../../shared/dynamic-report/pie-chart/pie-chart.module';
import { DynamicReportBubleChartModule } from '../../../../shared/dynamic-report/buble-chart/buble-chart.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MATERIALS } from '../../../../app.materials';
import { B2CAdminDashboardFiltersModule } from '../filters/b2c-admin-filters.module';

@NgModule({
    imports: [
        MATERIALS,
        BaseModule,
        PaginationModule,
        DynamicReportRoutesModule,
        TooltipModule,
        B2CAdminDashboardFiltersModule,
        DynamicReportBubleChartModule,
        DynamicReportPieChartModule
    ],
    exports: [
        DynamicReportComponent
    ],
    declarations: [
        DynamicReportComponent
    ],
    providers: [
    ]
})
export class DynamicReportModule { }
